import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, IconButton, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';

/**
 * A ProgProdTier referenced from another Entity, shown as its tier number and linked to the Tier itself. The Tier's
 * code only repeats the owning Program Product's code with the number appended, so the number is what identifies it.
 */
export const TierLinkField = ({ fieldDef }) => {
  const { formValues } = useForm();
  const { error, helperText, label, disabled, variant } = useFormFieldDef(fieldDef);
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();

  const tierId = formValues[fieldDef.field];
  const [tierNum, setTierNum] = useState(null);

  useEffect(() => {
    let current = true;
    setTierNum(null);
    if (!tierId) return;

    rsrc.byId('md', 'PROG_PROD_TIER', tierId).then((tier) => {
      if (current) setTierNum(tier?.tier ?? null);
    });

    return () => {
      current = false;
    };
  }, [tierId]);

  const navigateToTier = (event) =>
    navigateTo('md/prog-prod-tier', { entityId: tierId, mode: Mode.DETAIL }, event.ctrlKey);

  return (
    <TextField
      fullWidth
      variant={variant}
      error={error}
      helperText={helperText}
      label={label}
      value={tierNum ?? ''}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: true,
          endAdornment: tierId && (
            <InputAdornment position="end">
              <IconButton edge="end" onClick={navigateToTier}>
                <Icon>
                  <FontAwesomeIcon style={{ width: '100%' }} icon={fas.faLink} />
                </Icon>
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
